export type THistoricalEvent = {
	year: number,
	description: string
}

export type THistoricalEvents = {
	title: string
	events: THistoricalEvent[]
}

export const historicalEvents: THistoricalEvents[] = [
	{
		title: "Наука",
		events: [
			{
				year: 2015,
				description: '13 сентября — частное солнечное затмение, видимое в Южной Африке и части Антарктиды'
			},
			{
				year: 2016,
				description: 'Телескоп «Хаббл» обнаружил самую удалённую из всех обнаруженных галактик, получившую обозначение GN-z11'
			},
			{
				year: 2017,
				description: 'Компания Tesla официально представила первый в мире электрический грузовик Tesla Semi'
			},
			{
				year: 2018,
				description: 'NASA запустило солнечную зондовую станцию Parker Solar Probe для исследования короны Солнца'
			},
			{
				year: 2019,
				description: 'Учёные впервые получили изображение чёрной дыры с помощью телескопа Event Horizon Telescope'
			}
		]
	},
	{
		title: "Литература",
		events: [
			{
				year: 2010,
				description: 'Марио Варгас Льоса получил Нобелевскую премию по литературе'
			},
			{
				year: 2011,
				description: 'Публикация романа «1Q84» Харуки Мураками в полном трёхкнижном издании'
			},
			{
				year: 2012,
				description: 'Хилари Мантел получила Букеровскую премию за роман «Дарители тел»'
			},
			{
				year: 2013,
				description: 'Элеанор Каттон стала самым молодым лауреатом Букеровской премии за «Светила»'
			},
			{
				year: 2014,
				description: 'Публикация романа «Сонни» Карла-Уве Кнаусгора и рост мировой популярности его автобиографического цикла'
			}
		]
	},
	{
		title: "Кино",
		events: [
			{
				year: 2005,
				description: 'Премьера фильма «Город грехов», ставшего визуальной революцией'
			},
			{
				year: 2006,
				description: 'Фильм «Отступники» Мартина Скорсезе получил «Оскар» как лучший фильм'
			},
			{
				year: 2007,
				description: 'Выход «Старикам тут не место», получившего 4 премии «Оскар»'
			},
			{
				year: 2008,
				description: '«Тёмный рыцарь» стал культурным феноменом и изменил супергеройский жанр'
			},
			{
				year: 2009,
				description: '«Аватар» Джеймса Кэмерона установил рекорд мировых сборов'
			}
		]
	},
	{
		title: "Театр",
		events: [
			{
				year: 2020,
				description: 'Пандемия COVID-19 привела к глобальному закрытию театров'
			},
			{
				year: 2021,
				description: 'Открытие и возобновление мюзиклов на Бродвее после карантина'
			},
			{
				year: 2022,
				description: 'Премьера нашумевшего спектакля «Лемминги» в лондонском Young Vic'
			},
			{
				year: 2023,
				description: 'Глобальный успех мюзикла «Мулан» в азиатских странах'
			},
			{
				year: 2024,
				description: 'Новые VR-театральные постановки получили массовое распространение'
			}
		]
	},
	{
		title: "Игры",
		events: [
			{
				year: 1995,
				description: 'Выход PlayStation, ставшей одной из самых популярных консолей'
			},
			{
				year: 1996,
				description: 'Релиз первой Tomb Raider — революции в 3D-экшене'
			},
			{
				year: 1997,
				description: 'Выход Final Fantasy VII, изменившей JRPG жанр'
			},
			{
				year: 1998,
				description: 'The Legend of Zelda: Ocarina of Time стала игрой года'
			},
			{
				year: 1999,
				description: 'Выход Counter-Strike как модификации Half-Life'
			}
		]
	},
	{
		title: "Технологии",
		events: [
			{
				year: 2000,
				description: 'Запуск PlayStation 2 — самой продаваемой консоли в истории'
			},
			{
				year: 2001,
				description: 'Выход первого iPod, изменившего музыкальную индустрию'
			},
			{
				year: 2002,
				description: 'Запуск сервисов онлайн-платежей PayPal как публичной компании'
			},
			{
				year: 2003,
				description: 'Официальное завершение международного проекта «Геном человека»'
			},
			{
				year: 2004,
				description: 'Основание Facebook и начало новой эпохи соцсетей'
			}
		]
	}
]

